import { Box, Flex } from '@mantine/core'

import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import classes from './ChatPlaceholder.module.css'

export function ChatPlaceholder() {
  return (
    <Flex className={classes.container}>
      <Box>
        <Title variant="h1">Speak with the user</Title>

        <Text variant="body_2_medium_black">
          Chat with the user to give personalized advice on their finances. You
          can only speak with a user if they have initiated a chat with you or
          granted you access to their financial information. You cannot initiate
          a chat with a user.
        </Text>
      </Box>
    </Flex>
  )
}
